<template>
  <el-dialog
    class="show-cert-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    :top="top"
  >
    <template v-if="$utils.isArray(content)">
      <div v-for="(item, index) in content" :key="index">
        <detail-section :title="item.title" :show-border="true">
          <div class="info-content">{{ item.content }}</div>
        </detail-section>
      </div>
    </template>
    <template v-else>
      <detail-section :show-title="false" :show-border="true">
        <div class="info-content">{{ content }}</div>
      </detail-section>
    </template>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">下载</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ShowCertDialog',
  data() {
    return {
      title: '',
      downloadName: '',
      dialogVisible: false,
      disabled: false,
      content: '',
      rowData: null,
      top: '20vh'
    }
  },
  methods: {
    handleCancel() {
      this.content = ''
      this.rowData = null
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.rowData = data
      this.title = data.title
      this.content = data.cert
      this.downloadName = data.downloadName
      this.top = data.top || '20vh';
      this.dialogVisible = true;
    },
    handleOk() {
      if (this.$utils.isArray(this.content)) {
        for (let i = 0; i < this.content.length; i++) {
          let item = this.content[i]
          let name = `${item.downloadName}.key`
          this.$utils.createFileAndDownload(name, item.content)
        }
      } else {
        let name = `${this.downloadName}.key`
        this.$utils.createFileAndDownload(name, this.content)
      }
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.show-cert-dialog {
  @include adaptation(
    (
      --show-cert-dialog-width: 800px,
      --show-cert-dialog-info-content-item-max-height: 210px,
      --show-cert-dialog-info-content-padding: 24px,
      --show-cert-dialog-info-content-line-height: 27px
    )
  );
  /deep/ .el-dialog {
    width: var(--show-cert-dialog-width);
  }

  .info-content {
    max-height: var(--show-cert-dialog-info-content-item-max-height);
    padding: var(--show-cert-dialog-info-content-padding);
    overflow-y: auto;
    line-height: var(--show-cert-dialog-info-content-line-height);
  }
}
</style>
